import { render, staticRenderFns } from "./user-center-study.vue?vue&type=template&id=92a90a14&scoped=true"
import script from "./user-center-study.vue?vue&type=script&lang=js"
export * from "./user-center-study.vue?vue&type=script&lang=js"
import style0 from "./user-center-study.vue?vue&type=style&index=0&id=92a90a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a90a14",
  null
  
)

export default component.exports